import React from "react";
import { Search, Banknote, CreditCard, CheckCircle } from "lucide-react";

const steps = [
  {
    id: 1,
    title: "Pilih",
    desc: "Cari campaign favorit",
    icon: Search,
    color: "text-cyan-600",
    bg: "bg-cyan-50",
  },
  {
    id: 2,
    title: "Nominal",
    desc: "Masukan jumlah donasi",
    icon: Banknote,
    color: "text-lime-600",
    bg: "bg-lime-50",
  },
  {
    id: 3,
    title: "Bayar",
    desc: "Pilih metode pembayaran",
    icon: CreditCard,
    color: "text-sky-600",
    bg: "bg-sky-50",
  },
  {
    id: 4,
    title: "Selesai",
    desc: "Donasi tersalurkan",
    icon: CheckCircle,
    color: "text-emerald-600",
    bg: "bg-emerald-50",
  },
];

const MudahBerbagiSteps: React.FC = () => {
  return (
    <section className="py-12 px-4 md:px-6 lg:px-8 bg-gray-100">
      {/* HEADER */}
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800">Mudah Berbagi</h2>
        <p className="text-gray-500 mt-2">4 Langkah sederhana menebar kebaikan.</p>
        <div className="w-16 h-1 bg-secondary mx-auto mt-3 rounded-full" />
      </div>

      {/* STEPS WRAPPER */}
      <div className="relative max-w-7xl mx-auto">
        {/* ROUTE LINE DESKTOP */}
        <div className="hidden lg:block absolute top-1/2 left-0 w-full -translate-y-1/2">
          <svg className="w-full h-24" viewBox="0 0 1200 100" fill="none">
            <path d="M50 50 C250 0, 350 100, 550 50 S850 0, 1050 50" stroke="#29abe2" strokeWidth="4" strokeDasharray="8 8" fill="none" />
          </svg>
        </div>

        {/* GRID */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 relative">
          {steps.map((step) => {
            const Icon = step.icon;
            return (
              <div key={step.id} className="relative bg-white rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300 p-6 text-center group">
                {/* NUMBER BADGE */}
                <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-primary2 text-white text-sm flex items-center justify-center font-semibold shadow">{step.id}</div>

                {/* ICON */}
                <div className={`mx-auto w-16 h-16 rounded-2xl flex items-center justify-center mb-4 ${step.bg} group-hover:scale-110 transition`}>
                  <Icon className={`w-8 h-8 ${step.color}`} />
                </div>

                {/* TEXT */}
                <h3 className="font-semibold text-gray-800 mb-1">
                  {step.id}. {step.title}
                </h3>
                <p className="text-sm text-gray-500">{step.desc}</p>

                {/* MOBILE CONNECTOR */}
                {step.id !== steps.length && <div className="lg:hidden absolute left-1/2 -bottom-6 -translate-x-1/2 w-0.5 h-6 bg-primary2" />}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default MudahBerbagiSteps;
